/**
 * @generated SignedSource<<1454940aae2c9099141b80f8ceffa4c4>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { Fragment, ReaderFragment } from 'relay-runtime';
export type JiraSprintState = "ACTIVE" | "CLOSED" | "FUTURE" | "%future added value";
import type { FragmentRefs } from "relay-runtime";
export type groupRow_issueTableGrouping_FirstGroupRow_firstGroupRow$data = {
  readonly fieldId: string | null | undefined;
  readonly fieldSetId?: string | null | undefined;
  readonly fieldType: string | null | undefined;
  readonly fieldValue: {
    readonly __typename: string;
    readonly goal?: {
      readonly id: string;
    };
    readonly group?: {
      readonly groupId: string;
      readonly id: string;
      readonly name: string;
    };
    readonly jqlTerm?: string;
    readonly label?: {
      readonly name: string | null | undefined;
    } | null | undefined;
    readonly number?: number | null | undefined;
    readonly option?: {
      readonly color: {
        readonly colorKey: string | null | undefined;
        readonly id: string | null | undefined;
      } | null | undefined;
      readonly id: string;
      readonly optionId: string;
      readonly value: string | null | undefined;
    } | null | undefined;
    readonly priority?: {
      readonly iconUrl: AGG$URL | null | undefined;
      readonly id: string;
      readonly name: string | null | undefined;
      readonly priorityId: string;
    };
    readonly sprint?: {
      readonly endDate: AGG$DateTime | null | undefined;
      readonly id: string;
      readonly name: string | null | undefined;
      readonly sprintId: string;
      readonly state: JiraSprintState | null | undefined;
    };
    readonly status?: {
      readonly id: string;
      readonly name: string | null | undefined;
      readonly statusCategory: {
        readonly id: string;
        readonly statusCategoryId: string;
      } | null | undefined;
    } | null | undefined;
    readonly user?: {
      readonly accountId: string;
      readonly id: string;
      readonly name: string;
      readonly picture: AGG$URL;
    } | null | undefined;
  } | null | undefined;
  readonly id: string;
  readonly issues: {
    readonly __id: string;
    readonly edges: ReadonlyArray<{
      readonly __typename: "JiraIssueEdge";
    } | null | undefined> | null | undefined;
    readonly " $fragmentSpreads": FragmentRefs<"childRowsPagination_issueTableHierarchy_queryData">;
  } | null | undefined;
  readonly jql: string;
  readonly " $fragmentSpreads": FragmentRefs<"groupHeader_issueTableGrouping">;
  readonly " $fragmentType": "groupRow_issueTableGrouping_FirstGroupRow_firstGroupRow";
};
export type groupRow_issueTableGrouping_FirstGroupRow_firstGroupRow$key = {
  readonly " $data"?: groupRow_issueTableGrouping_FirstGroupRow_firstGroupRow$data;
  readonly " $fragmentSpreads": FragmentRefs<"groupRow_issueTableGrouping_FirstGroupRow_firstGroupRow">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "kind": "ScalarField",
  "name": "id"
},
v1 = {
  "kind": "ScalarField",
  "name": "__typename"
},
v2 = {
  "kind": "ScalarField",
  "name": "name"
};
return {
  "argumentDefinitions": [
    {
      "kind": "RootArgument",
      "name": "__relay_internal__pv__atlassianjirarelayprovidersrcgroupbyanyfieldstechnicalrelayprovider"
    },
    {
      "kind": "RootArgument",
      "name": "fieldSetsInput"
    },
    {
      "kind": "RootArgument",
      "name": "fieldSetsScope"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "isConditionalFormattingEnabled"
    },
    {
      "defaultValue": false,
      "kind": "LocalArgument",
      "name": "isDensityFull"
    },
    {
      "defaultValue": true,
      "kind": "LocalArgument",
      "name": "isInlineEditingEnabled"
    },
    {
      "defaultValue": false,
      "kind": "LocalArgument",
      "name": "isReparentingEnabled"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "isTimelineEnabled"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "projectKey"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "projectKeys"
    }
  ],
  "kind": "Fragment",
  "metadata": {
    "connection": [
      {
        "count": null,
        "cursor": null,
        "direction": "forward",
        "path": [
          "issues"
        ]
      }
    ]
  },
  "name": "groupRow_issueTableGrouping_FirstGroupRow_firstGroupRow",
  "selections": [
    (v0/*: any*/),
    {
      "kind": "RequiredField",
      "field": {
        "kind": "ScalarField",
        "name": "jql"
      },
      "action": "THROW",
      "path": "jql"
    },
    {
      "kind": "ScalarField",
      "name": "fieldId"
    },
    {
      "kind": "ScalarField",
      "name": "fieldType"
    },
    {
      "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcgroupbyanyfieldstechnicalrelayprovider",
      "kind": "Condition",
      "passingValue": true,
      "selections": [
        {
          "kind": "ScalarField",
          "name": "fieldSetId"
        }
      ]
    },
    {
      "kind": "LinkedField",
      "name": "fieldValue",
      "plural": false,
      "selections": [
        (v1/*: any*/),
        {
          "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcgroupbyanyfieldstechnicalrelayprovider",
          "kind": "Condition",
          "passingValue": true,
          "selections": [
            {
              "kind": "ScalarField",
              "name": "jqlTerm"
            },
            {
              "kind": "InlineFragment",
              "selections": [
                {
                  "concreteType": "JiraLabel",
                  "kind": "LinkedField",
                  "name": "label",
                  "plural": false,
                  "selections": [
                    (v2/*: any*/)
                  ]
                }
              ],
              "type": "JiraJqlLabelFieldValue"
            },
            {
              "kind": "InlineFragment",
              "selections": [
                {
                  "concreteType": "JiraGroup",
                  "kind": "LinkedField",
                  "name": "group",
                  "plural": false,
                  "selections": [
                    (v0/*: any*/),
                    {
                      "kind": "ScalarField",
                      "name": "groupId"
                    },
                    (v2/*: any*/)
                  ]
                }
              ],
              "type": "JiraJqlGroupFieldValue"
            }
          ]
        },
        {
          "kind": "InlineFragment",
          "selections": [
            {
              "concreteType": "JiraPriority",
              "kind": "LinkedField",
              "name": "priority",
              "plural": false,
              "selections": [
                (v0/*: any*/),
                {
                  "kind": "ScalarField",
                  "name": "priorityId"
                },
                (v2/*: any*/),
                {
                  "kind": "ScalarField",
                  "name": "iconUrl"
                }
              ]
            }
          ],
          "type": "JiraJqlPriorityFieldValue"
        },
        {
          "kind": "InlineFragment",
          "selections": [
            {
              "kind": "LinkedField",
              "name": "user",
              "plural": false,
              "selections": [
                (v0/*: any*/),
                {
                  "kind": "ScalarField",
                  "name": "accountId"
                },
                (v2/*: any*/),
                {
                  "kind": "ScalarField",
                  "name": "picture"
                }
              ]
            }
          ],
          "type": "JiraJqlUserFieldValue"
        },
        {
          "kind": "InlineFragment",
          "selections": [
            {
              "concreteType": "JiraStatus",
              "kind": "LinkedField",
              "name": "status",
              "plural": false,
              "selections": [
                (v0/*: any*/),
                (v2/*: any*/),
                {
                  "concreteType": "JiraStatusCategory",
                  "kind": "LinkedField",
                  "name": "statusCategory",
                  "plural": false,
                  "selections": [
                    (v0/*: any*/),
                    {
                      "kind": "ScalarField",
                      "name": "statusCategoryId"
                    }
                  ]
                }
              ]
            }
          ],
          "type": "JiraJqlStatusFieldValue"
        },
        {
          "kind": "InlineFragment",
          "selections": [
            {
              "kind": "ScalarField",
              "name": "number"
            }
          ],
          "type": "JiraJqlNumberFieldValue"
        },
        {
          "kind": "InlineFragment",
          "selections": [
            {
              "concreteType": "JiraOption",
              "kind": "LinkedField",
              "name": "option",
              "plural": false,
              "selections": [
                (v0/*: any*/),
                {
                  "kind": "ScalarField",
                  "name": "optionId"
                },
                {
                  "kind": "ScalarField",
                  "name": "value"
                },
                {
                  "concreteType": "JiraColor",
                  "kind": "LinkedField",
                  "name": "color",
                  "plural": false,
                  "selections": [
                    {
                      "kind": "ScalarField",
                      "name": "colorKey"
                    },
                    (v0/*: any*/)
                  ]
                }
              ]
            }
          ],
          "type": "JiraJqlOptionFieldValue"
        },
        {
          "kind": "InlineFragment",
          "selections": [
            {
              "concreteType": "JiraSprint",
              "kind": "LinkedField",
              "name": "sprint",
              "plural": false,
              "selections": [
                (v0/*: any*/),
                {
                  "kind": "ScalarField",
                  "name": "sprintId"
                },
                (v2/*: any*/),
                {
                  "kind": "ScalarField",
                  "name": "state"
                },
                {
                  "kind": "ScalarField",
                  "name": "endDate"
                }
              ]
            }
          ],
          "type": "JiraJqlSprintFieldValue"
        },
        {
          "kind": "InlineFragment",
          "selections": [
            {
              "concreteType": "JiraGoal",
              "kind": "LinkedField",
              "name": "goal",
              "plural": false,
              "selections": [
                (v0/*: any*/)
              ]
            }
          ],
          "type": "JiraJqlGoalsFieldValue"
        }
      ]
    },
    {
      "kind": "FragmentSpread",
      "name": "groupHeader_issueTableGrouping"
    },
    {
      "alias": "issues",
      "args": [
        {
          "kind": "Variable",
          "name": "fieldSetsInput",
          "variableName": "fieldSetsInput"
        },
        {
          "kind": "Variable",
          "name": "scope",
          "variableName": "fieldSetsScope"
        }
      ],
      "concreteType": "JiraIssueConnection",
      "kind": "LinkedField",
      "name": "__firstGroupSection_nativeIssueTable__issues_connection",
      "plural": false,
      "selections": [
        {
          "concreteType": "JiraIssueEdge",
          "kind": "LinkedField",
          "name": "edges",
          "plural": true,
          "selections": [
            (v1/*: any*/),
            {
              "kind": "ScalarField",
              "name": "cursor"
            },
            {
              "concreteType": "JiraIssue",
              "kind": "LinkedField",
              "name": "node",
              "plural": false,
              "selections": [
                (v1/*: any*/)
              ]
            }
          ]
        },
        {
          "args": [
            {
              "kind": "Variable",
              "name": "isConditionalFormattingEnabled",
              "variableName": "isConditionalFormattingEnabled"
            },
            {
              "kind": "Variable",
              "name": "isDensityFull",
              "variableName": "isDensityFull"
            },
            {
              "kind": "Variable",
              "name": "isInlineEditingEnabled",
              "variableName": "isInlineEditingEnabled"
            },
            {
              "kind": "Variable",
              "name": "isReparentingEnabled",
              "variableName": "isReparentingEnabled"
            },
            {
              "kind": "Variable",
              "name": "isTimelineEnabled",
              "variableName": "isTimelineEnabled"
            },
            {
              "kind": "Variable",
              "name": "projectKey",
              "variableName": "projectKey"
            },
            {
              "kind": "Variable",
              "name": "projectKeys",
              "variableName": "projectKeys"
            },
            {
              "kind": "Literal",
              "name": "shouldQueryHasChildren",
              "value": false
            }
          ],
          "kind": "FragmentSpread",
          "name": "childRowsPagination_issueTableHierarchy_queryData"
        },
        {
          "concreteType": "PageInfo",
          "kind": "LinkedField",
          "name": "pageInfo",
          "plural": false,
          "selections": [
            {
              "kind": "ScalarField",
              "name": "endCursor"
            },
            {
              "kind": "ScalarField",
              "name": "hasNextPage"
            }
          ]
        },
        {
          "kind": "ClientExtension",
          "selections": [
            {
              "kind": "ScalarField",
              "name": "__id"
            }
          ]
        }
      ]
    }
  ],
  "type": "JiraSpreadsheetGroup"
};
})();

(node as any).hash = "c0c2e198592f09b9e4da987252d0052c";

export default node;
